import { Injectable } from '@angular/core';
import { AppSettings } from '@library/plugin-settings/src/public_api';
import { NotificationSettingsModel } from './notification-settings.page';
import { DeviceNotificationService } from '@library/plugin-device-notification/src/public_api';
import moment from 'moment';
import { PodcastsNotificationService } from '@library/plugin-exercise/src/public_api';
import { FormService } from '../generic-form/form.service';

@Injectable({
    providedIn: 'root',
})
export class NotificationUpdaterService {
    photoNotificationIds: number[];
    skincareNotificationIds: number[];
    userGoalNotificationIds: number[];
    usageNotificationIds: number[];
    actionNotificationIds: number[];
    notificationSettings: NotificationSettingsModel;
    notificationTime: number[] = []; // index 0 = hours, 1 = minutes
    currentDay: number;
    lastActionDate;

    constructor(
        private settings: AppSettings,
        private notificationService: DeviceNotificationService,
        private podcastsService: PodcastsNotificationService,
        private formService: FormService
    ) {}

    async run() {
        this.setup();
        await this.createPhotoNotifications();
        await this.createSkincareNotifications();
        await this.createUserGoalNotifications();
        await this.createUsageNotification();
        await this.createActionNotification();
        // await this.formService.createFormNotifications();
        await this.podcastsService.createPodcastNotifications();
        console.log('! DONE UPDATING NOTIFICATIONS !');
    }

    private async createPhotoNotifications() {
        let ready = await this.notificationService.setup();
        if (ready) {
            await this.deletePhotoNotifications();
            let notificationIds = [];
            if (this.currentDay !== 7) {
                // Create notifications for this week and next week
                let nextNotificationDate = moment()
                    .set('day', 7)
                    .set('hour', this.notificationTime[0])
                    .set('minutes', this.notificationTime[1]);
                notificationIds.push(
                    this.notificationService.schedule(
                        'MiA Hautdokumentation',
                        `Hey ${this.notificationSettings.username}, Es ist wieder soweit! Überprüfe, wie sich dein Hautzustand verändert hat und halte ihn jetzt fest.`,
                        true,
                        nextNotificationDate
                    )
                );
                notificationIds.push(
                    this.notificationService.schedule(
                        'MiA Hautdokumentation',
                        `Hey ${this.notificationSettings.username}, Es ist wieder soweit! Überprüfe, wie sich dein Hautzustand verändert hat und halte ihn jetzt fest.`,
                        true,
                        nextNotificationDate.clone().add(1, 'week')
                    )
                );
            }
            // Sunday case
            else {
                if (this.isPreNotification()) {
                    let notificationDate = moment().set('hour', this.notificationTime[0]).set('minute', this.notificationTime[1]);
                    let id = this.notificationService.schedule(
                        'MiA Hautdokumentation',
                        `Hey ${this.notificationSettings.username}, es ist wieder soweit! Überprüfe, wie sich dein Hautzustand verändert hat und halte ihn jetzt fest.`,
                        true,
                        notificationDate
                    );
                    notificationIds.push(id);
                }
                // Create for next two weeks
                let nextNotificationDate = moment()
                    .set('hour', this.notificationTime[0])
                    .set('minute', this.notificationTime[1])
                    .add(1, 'week');
                notificationIds.push(
                    this.notificationService.schedule(
                        'MiA Hautdokumentation',
                        `Hey ${this.notificationSettings.username}, es ist wieder soweit! Überprüfe, wie sich dein Hautzustand verändert hat und halte ihn jetzt fest.`,
                        true,
                        nextNotificationDate
                    )
                );
                notificationIds.push(
                    this.notificationService.schedule(
                        'MiA Hautdokumentation',
                        `Hey ${this.notificationSettings.username}, es ist wieder soweit! Überprüfe, wie sich dein Hautzustand verändert hat und halte ihn jetzt fest.`,
                        true,
                        nextNotificationDate.clone().add(1, 'week')
                    )
                );
            }
            this.photoNotificationIds = notificationIds;
            this.settings.set('photo-notification-ids', this.photoNotificationIds);
        }
    }

    private async createSkincareNotifications() {
        let ready = await this.notificationService.setup();
        if (ready) {
            await this.deleteSkincareNotifications();
            // 0 = First week, 1 = second, 2 = third.....
            let currentWeek = moment().diff(moment(this.notificationSettings.startDate), 'week');
            let notificationIds = [];
            switch (currentWeek) {
                // Weeks 1,2 = daily
                case 0:
                case 1: {
                    for (let i = 1; i < 7; i++) {
                        notificationIds.push(
                            this.notificationService.schedule(
                                'MiA Hautschutzverhalten',
                                `Hey ${this.notificationSettings.username}, es ist wieder soweit – trage dein heutiges Hautschutzverhalten ein.`,
                                true,
                                moment().add(i, 'day').set('hour', this.notificationTime[0]).set('minute', this.notificationTime[1])
                            )
                        );
                    }
                    if (this.isPreNotification()) {
                        notificationIds.push(
                            this.notificationService.schedule(
                                'MiA Hautschutzverhalten',
                                `Hey ${this.notificationSettings.username}, es ist wieder soweit – trage dein heutiges Hautschutzverhalten ein.`,
                                true,
                                moment().set('hour', this.notificationTime[0]).set('minute', this.notificationTime[1])
                            )
                        );
                    }
                    break;
                }
                // Weeks 3,4,5,6 = every Friday
                case 2:
                case 3:
                case 4:
                case 5: {
                    notificationIds.push(
                        this.notificationService.schedule(
                            'MiA Hautschutzverhalten',
                            `Hey ${this.notificationSettings.username}, es ist wieder soweit – trage dein heutiges Hautschutzverhalten ein.`,
                            true,
                            moment()
                                .add(1, 'week')
                                .set('day', 5)
                                .set('hour', this.notificationTime[0])
                                .set('minute', this.notificationTime[1])
                        )
                    );
                    notificationIds.push(
                        this.notificationService.schedule(
                            'MiA Hautschutzverhalten',
                            `Hey ${this.notificationSettings.username}, es ist wieder soweit – trage dein heutiges Hautschutzverhalten ein.`,
                            true,
                            moment()
                                .add(2, 'week')
                                .set('day', 5)
                                .set('hour', this.notificationTime[0])
                                .set('minute', this.notificationTime[1])
                        )
                    );
                    if (this.currentDay < 5 || (this.currentDay === 5 && this.isPreNotification())) {
                        notificationIds.push(
                            this.notificationService.schedule(
                                'MiA Hautschutzverhalten',
                                `Hey ${this.notificationSettings.username}, es ist wieder soweit – trage dein heutiges Hautschutzverhalten ein.`,
                                true,
                                moment().set('day', 5).set('hour', this.notificationTime[0]).set('minute', this.notificationTime[1])
                            )
                        );
                    }
                    break;
                }
                default: {
                    // Week 7+ case (First notification friday week 8)
                    if (currentWeek >= 6) {
                        // Notification week case
                        if ((currentWeek + 1) % 2 === 0) {
                            if (this.currentDay < 5 || (this.currentDay === 5 && this.isPreNotification())) {
                                notificationIds.push(
                                    this.notificationService.schedule(
                                        'MiA Hautschutzverhalten',
                                        `Hey ${this.notificationSettings.username}, es ist wieder soweit – trage dein heutiges Hautschutzverhalten ein.`,
                                        true,
                                        moment().set('day', 5).set('hour', this.notificationTime[0]).set('minute', this.notificationTime[1])
                                    )
                                );
                            }
                            notificationIds.push(
                                this.notificationService.schedule(
                                    'MiA Hautschutzverhalten',
                                    `Hey ${this.notificationSettings.username}, es ist wieder soweit – trage dein heutiges Hautschutzverhalten ein.`,
                                    true,
                                    moment()
                                        .add(2, 'week')
                                        .set('day', 5)
                                        .set('hour', this.notificationTime[0])
                                        .set('minute', this.notificationTime[1])
                                )
                            );
                        } else {
                            // Notification next week and in 3 weeks
                            notificationIds.push(
                                this.notificationService.schedule(
                                    'MiA Hautschutzverhalten',
                                    `Hey ${this.notificationSettings.username}, es ist wieder soweit – trage dein heutiges Hautschutzverhalten ein.`,
                                    true,
                                    moment()
                                        .add(1, 'week')
                                        .set('day', 5)
                                        .set('hour', this.notificationTime[0])
                                        .set('minute', this.notificationTime[1])
                                )
                            );
                            notificationIds.push(
                                this.notificationService.schedule(
                                    'MiA Hautschutzverhalten',
                                    `Hey ${this.notificationSettings.username}, es ist wieder soweit – trage dein heutiges Hautschutzverhalten ein.`,
                                    true,
                                    moment()
                                        .add(3, 'week')
                                        .set('day', 5)
                                        .set('hour', this.notificationTime[0])
                                        .set('minute', this.notificationTime[1])
                                )
                            );
                        }
                    }
                    // Case Aftercarestart in future = same as first two weeks
                    else if (currentWeek < 0) {
                        for (let i = 1; i < 7; i++) {
                            notificationIds.push(
                                this.notificationService.schedule(
                                    'MiA Hautschutzverhalten',
                                    `Hey ${this.notificationSettings.username}, es ist wieder soweit – trage dein heutiges Hautschutzverhalten ein.`,
                                    true,
                                    moment().add(i, 'day').set('hour', this.notificationTime[0]).set('minute', this.notificationTime[1])
                                )
                            );
                        }
                        if (this.isPreNotification()) {
                            notificationIds.push(
                                this.notificationService.schedule(
                                    'MiA Hautschutzverhalten',
                                    `Hey ${this.notificationSettings.username}, es ist wieder soweit – trage dein heutiges Hautschutzverhalten ein.`,
                                    true,
                                    moment().set('hour', this.notificationTime[0]).set('minute', this.notificationTime[1])
                                )
                            );
                        }
                        break;
                    }
                    break;
                }
            }

            this.skincareNotificationIds = notificationIds;
            this.settings.set('skincare-notification-ids', this.skincareNotificationIds);
        }
    }

    private async createUsageNotification() {
        let ready = await this.notificationService.setup();
        if (ready) {
            await this.deletUsageNotifications();
            this.usageNotificationIds.push(
                this.notificationService.schedule(
                    'MiA - Benötigst du Hilfe?',
                    `Hey ${this.notificationSettings.username}! Du hast länger nicht mehr in deiner Hautschutz-App vorbeigeschaut. Brauchst du bei etwas Hilfe? Vielleicht können wir dir helfen.​`,
                    true,
                    moment().add(7, 'day').set('hour', 12).set('minute', 0)
                )
            );
            this.settings.set('usage-notification-ids', this.usageNotificationIds);
        }
    }

    private async createActionNotification() {
        let ready = await this.notificationService.setup();
        if (ready) {
            await this.deletActionNotifications();
            this.actionNotificationIds.push(
                this.notificationService.schedule(
                    'MiA - Benötigst du Hilfe?',
                    `Hey ${this.notificationSettings.username}! Du hast länger nichts mehr in deiner Hautschutz-App eingetragen. Brauchst du bei etwas Hilfe? Vielleicht können wir dir helfen.​`,
                    true,
                    moment(this.lastActionDate).add(7, 'day').set('hour', 12).set('minute', 0)
                )
            );
            this.settings.set('action-notification-ids', this.actionNotificationIds);
        }
    }

    private async createUserGoalNotifications() {
        let ready = await this.notificationService.setup();
        if (ready) {
            await this.deleteUserGoalNotifications();
            let notificationIds = [];
            if (this.currentDay !== 5) {
                // create notifications for this week and next week
                let nextNotificationDate = moment()
                    .set('day', 5)
                    .set('hour', this.notificationTime[0])
                    .set('minutes', this.notificationTime[1]);
                notificationIds.push(
                    this.notificationService.schedule(
                        'MiA Zielerreichung',
                        `Hey ${this.notificationSettings.username}, es ist wieder soweit! Bitte überprüfe, ob Du Deine Ziele erreicht hast.`,
                        true,
                        nextNotificationDate
                    )
                );
                notificationIds.push(
                    this.notificationService.schedule(
                        'MiA Zielerreichung',
                        `Hey ${this.notificationSettings.username}, es ist wieder soweit! Bitte überprüfe, ob Du Deine Ziele erreicht hast.`,
                        true,
                        nextNotificationDate.clone().add(1, 'week')
                    )
                );
            } else {
                // Friday case
                if (this.isPreNotification()) {
                    let notificationDate = moment().set('hour', this.notificationTime[0]).set('minute', this.notificationTime[1]);
                    let id = this.notificationService.schedule(
                        'MiA Zielerreichung',
                        `Hey ${this.notificationSettings.username}, es ist wieder soweit! Bitte überprüfe, ob Du Deine Ziele erreicht hast.`,
                        true,
                        notificationDate
                    );
                    notificationIds.push(id);
                }
                // create for next two weeks
                let nextNotificationDate = moment()
                    .set('hour', this.notificationTime[0])
                    .set('minute', this.notificationTime[1])
                    .add(1, 'week');
                notificationIds.push(
                    this.notificationService.schedule(
                        'MiA Zielerreichung',
                        `Hey ${this.notificationSettings.username}, es ist wieder soweit! Bitte überprüfe, ob Du Deine Ziele erreicht hast.`,
                        true,
                        nextNotificationDate
                    )
                );
                notificationIds.push(
                    this.notificationService.schedule(
                        'MiA Zielerreichung',
                        `Hey ${this.notificationSettings.username}, es ist wieder soweit! Bitte überprüfe, ob Du Deine Ziele erreicht hast.`,
                        true,
                        nextNotificationDate.clone().add(1, 'week')
                    )
                );
            }
            this.userGoalNotificationIds = notificationIds;
            this.settings.set('usergoal-notification-ids', this.userGoalNotificationIds);
        }
    }

    private isPreNotification() {
        return (
            moment().get('hour') < this.notificationTime[0] ||
            (moment().get('hour') === this.notificationTime[0] && moment().get('minute') < this.notificationTime[1])
        );
    }

    private async deletePhotoNotifications() {
        this.photoNotificationIds.forEach(async (e) => {
            let result = await this.notificationService.remove(e);
        });
        this.photoNotificationIds = [];
        this.settings.set('photo-notification-ids', this.photoNotificationIds);
    }

    private async deleteSkincareNotifications() {
        this.skincareNotificationIds.forEach(async (e) => {
            let result = await this.notificationService.remove(e);
        });
        this.skincareNotificationIds = [];
        this.settings.set('skincare-notification-ids', this.skincareNotificationIds);
    }

    private async deleteUserGoalNotifications() {
        this.userGoalNotificationIds.forEach(async (e) => {
            let result = await this.notificationService.remove(e);
        });
        this.userGoalNotificationIds = [];
        this.settings.set('usergoal-notification-ids', this.userGoalNotificationIds);
    }

    private async deletUsageNotifications() {
        this.usageNotificationIds.forEach(async (e) => {
            let result = await this.notificationService.remove(e);
        });
        this.usageNotificationIds = [];
        this.settings.set('usage-notification-ids', this.usageNotificationIds);
    }

    private async deletActionNotifications() {
        this.actionNotificationIds.forEach(async (e) => {
            let result = await this.notificationService.remove(e);
        });
        this.actionNotificationIds = [];
        this.settings.set('action-notification-ids', this.actionNotificationIds);
    }

    private setup() {
        this.notificationTime = [];
        this.photoNotificationIds = this.settings.get('photo-notification-ids');
        if (!this.photoNotificationIds) {
            this.photoNotificationIds = [];
            this.settings.set('photo-notification-ids', this.photoNotificationIds);
        }
        this.skincareNotificationIds = this.settings.get('skincare-notification-ids');
        if (!this.skincareNotificationIds) {
            this.skincareNotificationIds = [];
            this.settings.set('skincare-notification-ids', this.skincareNotificationIds);
        }
        this.userGoalNotificationIds = this.settings.get('usergoal-notification-ids');
        if (!this.userGoalNotificationIds) {
            this.userGoalNotificationIds = [];
            this.settings.set('usergoal-notification-ids', this.userGoalNotificationIds);
        }
        this.usageNotificationIds = this.settings.get('usage-notification-ids');
        if (!this.usageNotificationIds) {
            this.usageNotificationIds = [];
            this.settings.set('usage-notification-ids', this.usageNotificationIds);
        }
        this.actionNotificationIds = this.settings.get('action-notification-ids');
        if (!this.actionNotificationIds) {
            this.actionNotificationIds = [];
            this.settings.set('action-notification-ids', this.actionNotificationIds);
        }
        this.lastActionDate = this.settings.get('lastaction-date');
        if (!this.lastActionDate) {
            this.settings.set('lastaction-date', moment().format());
        }

        const username = this.settings.get('notification-username') || 'MiA Nutzer:in';
        const notificationTime = this.settings.get('notification-time') || '12:00';
        const startDate = this.settings.get('aftercare-start-date') || moment().toISOString();
        this.notificationSettings = {
            username: username,
            startDate: moment(startDate).toISOString(),
            notificationTime: notificationTime,
        };

        this.currentDay = moment().get('day');
        this.notificationSettings.notificationTime.split(':').forEach((e) => this.notificationTime.push(Number(e)));
    }
}

